export const healthProjects = [
  {
    tag: "Leadership · Community Health",
    title: "Community Health Ambassadors Initiative",
    desc: "A student-led public health initiative promoting preventive health practices, environmental hygiene, and workplace safety. Recruited and coordinated 20 coursemates to run workshops and outreach programs in collaboration with local health workers.",
    foot: "Aug 2023 – Present · Founder & Coordinator",
    detailPath: "/projects/community-health-ambassadors",
  },
  {
    tag: "Volunteering · Disability Inclusion",
    title: "EB Volunteer Activities",
    desc: "Sustained engagement in community health and disability outreach, facilitating health education and workplace safety awareness, collecting and analysing community health data, and advocating for disability inclusion to strengthen community resilience.",
    foot: "2019 – Present · Community Programs",
    detailPath: "/projects/volunteer-activities",
  },
  {
    tag: "Research · Adolescent Health",
    title: "Autism & Sex Education",
    desc: "Undergraduate research examining the knowledge and perceptions of caregivers on sex education for teenagers with autism. Mixed-methods data collection and quantitative Excel analysis; findings presented to faculty.",
    foot: "KNUST 2023 · Undergraduate Research",
    detailPath: "/projects/autism-sex-education",
  },
];

export const webdevProjects = [
  {
    tag: "PWA + Mobile · Special Needs Ed-Tech",
    title: "KASA",
    desc: "An offline-first collaboration platform connecting parents, teachers, and therapists around students with special needs in Ghanaian schools. Provides student profiles, IEP goal tracking, teacher-parent messaging, therapy session notes, and a photo/video journal, all designed to run on low-bandwidth and low-connectivity devices.",
    links: [
      { type: "live", label: "Live Site", href: "https://kasa.ellenboakye.online" },
      { type: "github", label: "GitHub Repo", href: "#" },
    ],
    detailPath: "/projects/kasa",
  },
  {
    tag: "Chrome Extension · Accessibility · Ed-Tech",
    title: "Extablify",
    desc: "A free, open-source browser extension helping students with visual impairments, dyslexia, and low vision access the web for academic study. Features voice-guided navigation, text-to-speech, high-contrast mode, text scaling, and a content cleaner. All offline-first, no account needed. Built for Ghanaian schools, designed to grow into a pan-African accessibility layer.",
    links: [
      { type: "live", label: "Live Site", href: "https://www.extablify.com" },
      { type: "github", label: "GitHub Repo", href: "https://github.com/ellenboakye/extablify" },
    ],
    detailPath: "/projects/extablify",
  },
];
